import { Injectable } from "@angular/core";

import { noop, Observable } from "rxjs";

import {
    Note,
    NoteBruger,
    NoteHenvendelsestype,
    NoteListeItem,
    NoteOmraade,
    NoteOpgavestyringStatus,
    opretTomNote
} from "../model/note.model";
import { NoteRepository } from "./note.repository";

@Injectable({ providedIn: "root" })
export class InstallationNoteService {
    constructor(private readonly repository: NoteRepository) {}

    public hentNoter(): Observable<NoteListeItem[]> {
        return this.repository.hentNoterForInstallation();
    }

    public hentOmraader(): Observable<NoteOmraade[]> {
        return this.repository.hentOmraader();
    }

    public hentHenvendelsestyper(): Observable<NoteHenvendelsestype[]> {
        return this.repository.hentHenvendelsestyper();
    }

    public hentOpgavestyringStatusser(): Observable<NoteOpgavestyringStatus[]> {
        return this.repository.hentOpgavestyringStatusser();
    }

    public hentBrugere(): Observable<NoteBruger[]> {
        return this.repository.hentBrugere();
    }

    public hentNote(id: NoteListeItem): Observable<Note> {
        return this.repository.hentNote(id);
    }

    public gemNote(note: Note, onProgress: (value: number) => void = noop): Promise<Note> {
        return this.repository.gemNote(note, onProgress);
    }

    public sletNote(note: Note): Promise<void> {
        return this.repository.sletNote(note);
    }

    public hentDefaultOmraadeId(): number {
        return null;
    }

    public opretTomNote(): Note {
        return opretTomNote(this.hentDefaultOmraadeId());
    }
}
